export enum LicenseUploadContext {
  OVERLAY = "overlay",
  LICENSE_PAGE = "licensePage",
}
